import React, { useContext } from 'react';
import { CalendarContext } from '../../context/CalendarContext';
import { format, isSameWeek } from 'date-fns';

const CalendarHeader = () => {
  const {
    startOfWeek,
    endOfWeek,
    goToPreviousWeek,
    goToNextWeek,
    goToCurrentWeek,
    currentDate
  } = useContext(CalendarContext);

  return (
    <div className="calendar-header">
      <div className="date-range">
        {format(startOfWeek, 'dd')} - {format(endOfWeek, 'dd MMMM yyyy')}
      </div>
      <div className="navigation">
        <button className={`btn-prev-week ${isSameWeek(new Date(), currentDate, { weekStartsOn: 1 }) ? 'disabled' : ''}`} onClick={goToPreviousWeek}>&lt;</button>
        <button onClick={goToCurrentWeek}>This week</button>
        <button className='btn-next-week' onClick={goToNextWeek}>&gt;</button>
      </div>
    </div>
  );
}

export default CalendarHeader
